<template>
    <dv-full-screen-container>
      <!--头部开始-->
      <el-row style="height: 10%">
        <el-col :xl="24" :lg="24" :md="24" :sm="24" :sx="24" style="height: 100%">
          <div class="header1 header">
            <div class=" header_time">
              <span class="year">{{ date }}</span>
              <span class="hour" style="margin-left: 10px">{{ time }}</span>
            </div>
            <div class="header_left_nav">
              <router-link to="/">
                <button class="butt ">首页</button>
              </router-link>
            </div>
            <div class="header_left_nav nav1" style="z-index: 100000000">
              <router-link to="/Arrondi2" >
                <button class="butt zq">文化</button>
              </router-link>
            </div>
            <div class=" header_title">
              <div class="header_img">
                <img src="../public/images/tixing.png" alt="">
                <div class="header_title_msg" style="left: 34%">
                    中药材数据大屏
                </div>
              </div>
            </div>
            <div class=" nav2 " style="z-index: 100000000">
              <router-link to="/Special2" >
                <button class="butt ">咱们店</button>
              </router-link>
            </div>
            <div class=" nav3">
              <router-link to="/SpecialCoun2" >
                <button class="butt "  style="width: 83px;">金雀田园</button>
              </router-link>
            </div>
            <div class=" nav5">
            <router-link to="/Traditional" >
            <button class="butt" >中药材</button>
            </router-link>
          </div>
            <div class=" nav6">
              <router-link to="/Information" >
                <button class="butt" >数据</button>
              </router-link>
            </div>
  
            <div class=" nav4">
              <button class="butt" v-on:click="login_out">退出</button>
            </div>
            <div class="clear-both"></div>
          </div>
        </el-col>
      </el-row>
      <!--头部完毕-->
      <el-row style="height: 45%">
        <el-col :span="8" style="height: 100%">
          <dv-border-box-12>
            <div class="title_msg">重点品种价格</div>
            <div style="height: 87%">
              
                <HerbComparisonChart />
           
            </div>
          </dv-border-box-12>
        </el-col>
  
        <el-col :span="8" style="height: 100%">
          <!-- <div class="title_msg">门店位置分布图</div> -->
          <div style="height: 90%">
            <HerbDistributionHeatMap msg="实时" style="padding: 0 3%; width: 94%; height: 100%"/>
          </div>
        </el-col>
        <el-col :span="8" style="height: 100%">
          <el-col :span="24" style="height: 100%; margin-top: 4%">
  
          
            
              <PatentTechDistribution msg="实时" style="padding: 0 3%; width: 94%; height: 100%"/>
             
        
          </el-col>
        </el-col>
      </el-row>
      <el-row style="height: 40%;margin-top: 2.5%">
        <el-col :span="8" style="height: 100%;">
          <dv-border-box-12>
            <div class="title_msg">中药材产业链价值流动图</div>
            <div style="height: 87%">
              <HerbSankeyChart />
            </div>
          </dv-border-box-12>
        </el-col>
        <el-col :span="16" style="height: 100%;">
          <dv-border-box-12>
            <div class="title_msg">研究热点演进图</div>
            <div style="height: 90%; ">
              <ResearchHotspotsEvolution msg="动态时时订单" style="padding: 0 3%; width: 94%; height: 90%"/>
            </div>
          </dv-border-box-12>
        </el-col>
      </el-row>
    </dv-full-screen-container>
  </template>
  
  <script>
  
  import HerbDistributionHeatMap from '@/views/traditional/HerbDistributionHeatMap.vue'
  import HerbComparisonChart from '@/views/traditional/HerbComparisonChart.vue'
  import HerbSankeyChart from '@/views/traditional/HerbSankeyChart.vue'
  // 添加新组件导入
  import ResearchHotspotsEvolution from '@/views/traditional/ResearchHotspotsEvolution.vue'
  // 添加新组件导入
  import PatentTechDistribution from '@/views/traditional/PatentTechDistribution.vue'
  
  export default {
    name: "traditional",
    data() {
      return {
        time:'',
        date:''
      }
    },
    components: {
      HerbDistributionHeatMap,
      HerbComparisonChart,
      HerbSankeyChart,
      ResearchHotspotsEvolution,
      // 注册新组件
      PatentTechDistribution,
    },
    mounted(){
  
      let user_id = window.localStorage.getItem('user_id');
  
      // if (!user_id)
      // {
      //   this.$router.push({ path: '/Login' })
      //
      //   return false;
      // }
  
      const data = {
        'user_id': user_id
      };

  
      const that = this;
      setInterval(updateTime, 1000);
      function updateTime() {
        const cd = new Date();
        that.time = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2);
        that.date = zeroPadding(cd.getFullYear(), 4) + '-' + zeroPadding(cd.getMonth()+1, 2) + '-' + zeroPadding(cd.getDate(), 2);
      };
  
      function zeroPadding(num, digit) {
        let zero = '';
        for(let i = 0; i < digit; i++) {
          zero += '0';
        }
        return (zero + num).slice(-digit);
      }
  
    },
    methods: {
      login_out:function(e){
        window.localStorage.clear();
        this.$notify({
          title: '成功',
          message: '退出登录',
          type: 'success'
        });
        this.$router.push({ path: '/Login' })
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  @import '../public/less/public/list.less';
  @import '../public/less/zhuanguan/zhuanguan.less';
  </style>